<template>
	<div class="hotspot-scene__caption" v-if="captionTitle || caption">
		<div class="hotspot-scene__caption-title" v-if="captionTitle" v-html="captionTitle"></div>
		<div class="hotspot-scene__caption-body" v-if="caption" v-html="caption"></div>
	</div>
	<div class="hotspot-scene__wrap">
		<div class="hotspot-scene__image-container">
			<div class="hotspot-scene__image-wrap">
				<img :src="backgroundImage" alt="scene background" class="hotspot-scene__image animate__animated" ref="primaryImage" @click="openFirstHotspot">
				<template v-for="(hotspot, index) in hotspotPlacements" :key="hotspot.Title">
					<Hotspot
						:topPositionY="hotspot.TopPosition"
						:leftPositionX="hotspot.LeftPosition"
						:index="index"
						:displayTitle="displayTitle"
						:modalVisible="modalVisible"
						:hotspotPlacementsLength="hotspotPlacements?.length"
						:color="hotspot.HotspotColorOverride ? hotspot.HotspotColorOverride : sceneAssociatedColor"
						@modalVisibilityUpdated="modalVisibilityUpdated"
						@updateActiveHotspotIndex="updateActiveHotspotIndex"
						:hotspots="hotspot.SelectHotspot"
					></Hotspot>
				</template>
			</div>
		</div>
	</div>
</template>

<script lang="ts" setup>
import { computed, ref, watch } from 'vue';

import Hotspot from 'Vue/components/hotspotComponents/Hotspot.vue';
import { HotspotPlacement } from 'Interfaces/interfaces';
const emit = defineEmits(['modalVisibilityUpdated','updateActiveHotspotIndex']);
const activeHotspotIndex = ref<number>(0);
const primaryImage = ref(null);
const componentName = 'HotspotScene';
const props = defineProps({
	backgroundImage: {
		type: String,
		default: ''
	},
	caption: {
		type: String,
		default: ''
	},
	captionTitle: {
		type: String,
		default: ''
	},
	displayTitle: {
		type: String,
		default: ''
	},
	activeIndex: {
		type: Number,
		default: 0
	},
	hotspotPlacements: {
		type: Array as () => HotspotPlacement[],
		default: []
	},
	title: {
		type: String,
		default: ''
	},
	modalVisible: {
		type: Boolean,
		default: false
	},
	id: {
		type: String,
		default: ''
	},
	sceneAssociatedColor: {
		type: String,
		default: ''
	}
});


const hotspotPlacements = computed(() => {
	let hotspotsArray = [];
	props.hotspotPlacements.forEach((hotspotPlacement) => {
		hotspotsArray.push(hotspotPlacement);
	})

	return hotspotsArray;
});

watch(() => props.activeIndex, (newValue) => {
	primaryImage.value.classList.remove('animate__fadeInRight');
	primaryImage.value.classList.add('animate__fadeInRight');
});


const updateActiveHotspotIndex = (indexValue) => {
	emit('updateActiveHotspotIndex', indexValue);
}

const openFirstHotspot = () => {
	emit('updateActiveHotspotIndex', 0);
	emit('modalVisibilityUpdated', true);
}

const modalVisibilityUpdated = (value) => {
	emit('modalVisibilityUpdated', value);
}
</script>
